import * as types from "../../constants/actionTypes";
import moment from 'moment';

const initState = {
    isLoading: false,
    listLayanan: [],
    masterData: [],
    formLayanan: {
        f_id_layanan: "",
        f_nama_layanan: "",
        f_tarif_layanan: "",
        f_status_administrasi: true,
        f_tarif_administrasi: "",
        f_catatan: null,
        f_id_klinik: "",
        f_id_poli: "",
        f_status_catatan: false,
    }
    
};

export default function (state = initState, action) {
    switch (action.type) {
        case types.MODULE_LAYANAN_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.MODULE_LAYANAN_DATA_GET_ALL_SUCCESS: {
            return{
                ...state,
                listLayanan: action.value
            }
        }
        case types.MODULE_LAYANAN_DATA_GET_DETAIL_SUCCESS: {
            return{
                ...state,
                formLayanan: action.value
            }
        }
        case types.MODULE_LAYANAN_MASTER_DATA_SUCCESS: {
            return{
                ...state,
                masterData: {
                    ...state.masterData,
                    [action.property] : action.value
                }
            }
        }
        case types.MODULE_LAYANAN_INIT_FORM_LAYANAN: {
            return {
                ...state,
                formLayanan: {
                    ...initState.formLayanan
                }
            }
        }
        case types.MODULE_LAYANAN_HANDLE_STATE_FORM: {
            return {
                ...state,
                formLayanan: {
                    ...state.formLayanan,
                    [action.property]: action.value,
                }
            }
        }
        default:
            return {
                ...state
            }
    }
}  